import PropTypes from 'prop-types';
import styles from './form-card.css';


export const FormCardStatusTypes = {
  VALID: 'VALID',
  INVALID: 'INVALID',
};

const getStatusTypeClass = (statusType) => {
  switch (statusType) {
    case FormCardStatusTypes.VALID: return styles.valid;
    case FormCardStatusTypes.INVALID: return styles.invalid;
    default: throw new Error('Invalid status type');
  }
};


const FormCard = ({
  status,
  header,
  content,
  className,
}) => (
  <div className={`${styles.container} ${className || ''}`}>
    {status && <div className={`${styles.statusContainer} ${getStatusTypeClass(status)}`} />}
    <div className={styles.cardContainer}>
      {header && (
        <div className={styles.headerContainer}>
          {header}
        </div>
      )}
      <div className={styles.contentContainer}>
        {content}
      </div>
    </div>
  </div>
);

FormCard.propTypes = {
  status: PropTypes.oneOf(Object.values(FormCardStatusTypes)),
  header: PropTypes.string,
  content: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default FormCard;
